import React, {useState} from 'react'
import {Form, Input, Button} from 'antd'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import logo from '../static/images/New_logo.jpg'
import apiRequest from '../hooks/ApiRequest'

const ForgotPassword = props => {
  const {form} = props
  const [loading, setLoading] = useState(false)

  const handleSubmit = async e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return

      setLoading(true)
      try {
        const response = await apiRequest(
          `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/forget-password/${values.email}`,
          'POST',
        )

        if (response.success) {
          toast.success(response.data.message || 'Reset link sent!', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 5000,
          })
          form.resetFields()
        } else {
          toast.error(response.error || 'Failed to send reset link.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 5000,
          })
        }
      } catch (err) {
        toast.error('Something went wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
        })
      } finally {
        setLoading(false)
      }
    })
  }

  const {getFieldDecorator} = form

  return (
    <div
      className="body-height"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
      }}>
      <div
        className="bg-white"
        style={{
          boxShadow: '0 0 16px grey',
          padding: '30px',
          borderRadius: '10px',
          textAlign: 'center',
          width: '100%',
          maxWidth: '400px',
        }}>
        <div className="wrap-img">
          <img
            src={logo}
            alt="Logo"
            style={{width: '250px', height: '100px', marginBottom: '10px'}}
          />
        </div>

        <h2 className="h2-password">Forgot Password</h2>

        <Form
          onSubmit={handleSubmit}
          layout="vertical"
          className="form-group-login">
          <Form.Item >
            {getFieldDecorator('email', {
              rules: [
                {required: true, message: 'Email is required'},
                {type: 'email', message: 'Invalid email format'},
              ],
            })(<Input placeholder="Enter Email" />)}
          </Form.Item>
          <Form.Item>
            <Button
              htmlType="submit"
              type="primary"
              size="large"
              loading={loading}
              style={{width: '100%'}}
              className="btn-bg-primary">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(ForgotPassword)
